import { render } from "./panel-toolbar.vue?vue&type=template&id=797cb1a4"
import script from "./panel-toolbar.vue?vue&type=script&lang=js"
export * from "./panel-toolbar.vue?vue&type=script&lang=js"

import "./panel-toolbar.vue?vue&type=style&index=0&id=797cb1a4&lang=css"
script.render = render

export default script